import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ChangeDetectorRef,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Questions } from 'src/app/common-class/questions';
import { Group } from 'src/app/common-class/pages';
import { Answers } from 'src/app/common-class/answers';
import { AnswerImage } from 'src/app/common-class/answer-image';
import { AnswerMedia } from 'src/app/common-class/answer-media';
import { CommonLogic } from 'src/app/COMMON-LOGIC/common-logic';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
declare var $: any;

@Component({
  selector: 'app-symbol-rating-scale',
  templateUrl: './symbol-rating-scale.component.html',
  styleUrls: ['./symbol-rating-scale.component.css'],
})
export class SymbolRatingScaleComponent implements OnInit {
  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() isDisplaySubQno: boolean;
  @Input() group: Group;
  @Input() isMobile: boolean;
  @Input() isNewParticipationButton: boolean;

  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions[];
  imgQuestion: Questions;
  firstQuestion: Questions;
  isMandatory: boolean;
  _isMandatoryInvalid: boolean;
  isFormSubmit: boolean = false;
  isFormSubmitSub: Subscription;
  isDisplaySubQNo: boolean = false;
  isPreview: boolean = false;
  isNewParticipation: boolean;
  surveyFormat: number = 0;
  newParticipationBtnText: string;
  showNewParticipationButton: boolean;
  isAnsChange: boolean = false;
  isNgOnChange: boolean;
  count: number = 0;
  isPreReadQn: boolean;
  resetPageSub: Subscription;

  ngOnChanges(changes: SimpleChanges) {
    let curVal;
    let preVal;
    const change = changes['JsonData'];
    if (change) {
      curVal = JSON.stringify(change.currentValue);
      preVal = JSON.stringify(change.previousValue);
    }
    if (curVal != preVal && preVal != undefined) {
      this.questions = JSON.parse(this.JsonData);
      this.isNgOnChange = true;
      this.count = 0;
      if (this.group.answer_style == 1) {
        this.questions = CommonLogic.RandomQuestionsHandling(this.questions);
      } else if (this.group.answer_style == 0 && this.questions.length > 1) {
        this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
      } else if (
        this.group.answer_style == 2 &&
        this.questions[0].grpRotateIndex != -1 &&
        this.questions.length > 1
      ) {
        this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
        CommonLogic.RotateQuestionsHandling(this.questions);
      }
      this.ngAfterViewInit();
      this.questions = this.questions.filter((e) => !e.isHiddenQ);
    }
  }

  constructor(
    private service: ParticipationDataService,
    private changeDetect: ChangeDetectorRef,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    if (this.questions == null) {
      this.questions = JSON.parse(this.JsonData);
      

      const fstQn = this.questions?.[0];
      if (fstQn != undefined && fstQn != null) {
        this.firstQuestion = fstQn;
      }

      const imgQn = this.questions?.find((e) => e.sub_qno == 1);
      if (imgQn != undefined && imgQn != null) {
        this.imgQuestion = imgQn;
      }
      if (this.group?.answer_style == 1) {
        this.questions = CommonLogic.RandomQuestionsHandling(this.questions);
      } else if (this.group?.answer_style == 0 && this.questions.length > 1) {
        this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
      } else if (
        this.group?.answer_style == 2 &&
        this.questions[0].grpRotateIndex != -1 &&
        this.questions.length > 1
      ) {
        this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
        CommonLogic.RotateQuestionsHandling(this.questions);
      }
      const mandatoryQuestion = this.questions?.filter((e) => e.mandatory);

      if (mandatoryQuestion != undefined && mandatoryQuestion != null) {
        if (mandatoryQuestion.length == this.questions.length) {
          this.isMandatory = true;
          this._isMandatoryInvalid = true;
        }
      }

      if (this.questions?.length == 1) {
        this.isDisplaySubQNo = false;
      } else {
        this.isDisplaySubQNo = true;
      }
    }

    // Subscibe To Form Submit/Next Event ( Event is fired when mandatory is not satisfied )
    this.isFormSubmitSub = this.service.emitFormSubmitEvent.subscribe((data) => {
      this.isFormSubmit = data;
    });

    this.isPreview = this.service.GroupType?.toUpperCase() == 'PREVIEW';
    this.isNewParticipation = this.service.isNewParticipation;
    this.surveyFormat = this.service.surveyFormat;
    this.newParticipationBtnText = this.service.newParticipationBtnText;
    this.showNewParticipationButton =
      (this.questions?.length > 1 || !this.service.isAutoScroll) && this.isNewParticipationButton;
    this.isPreReadQn = this.questions?.filter((e) => e.population_type == 3).length > 0;
    this.questions = this.questions?.filter((e) => !e.isHiddenQ);
  }

  ngAfterViewInit() {
    // Handle Chrome-specific styling with native DOM operations
    if (window.navigator.userAgent.indexOf('Chrome') != -1) {
      const answerParentElements = this.elementRef.nativeElement.querySelectorAll('.answerParent');
      answerParentElements.forEach(element => {
        this.renderer.setStyle(element, 'width', 'calc(100% + 1px)');
      });
    }

    const elemid = '#dv_' + this.firstQuestion?.UniqueNumber;
    this.setLabelWidth(elemid);
    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if (data) {
        this.isAnsChange = false;
      }
    });
  }

  ngOnDestroy() {
    this.isFormSubmitSub.unsubscribe();
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  ngOnChangesEventHandle(no: number) {
    if (no == this.questions.length - 1) {
      this.ngAfterViewInit();
      this.count++;
    }
  }

  UpdateQuestionsData(question: Questions) {
    this.isAnsChange = true;
    this.ChangeAnswersData.emit(question);
  }

  GetQuestionsString(question): string {
    return JSON.stringify(question);
  }

  GetAnswerImages(question: Questions): AnswerImage[] {
    if (question.Answers[0].AnswerImages != null) {
      return question.Answers[0].AnswerImages;
    }
  }

  GetAnswerMedias(question: Questions): AnswerMedia[] {
    if (question.Answers[0].AnswerMedias != null) {
      return question.Answers[0].AnswerMedias;
    }
  }

  clickEventHandle(answer: Answers, question: Questions, event) {
    if (answer.selectdId == 0) {
      this.SelectedValue(answer, question);
    } else {
      this.ClickEventHandling(answer, question);
    }
    this.nextQuestion(event);
  }

  SelectedValue(answer: Answers, question: Questions) {
    if (question.Answers != null) {
      for (let i = 0; i < question.Answers.length; i++) {
        if (answer.ms_id === question.Answers[i].ms_id) {
          answer.selectdId = 1;
          answer.ControlAns = answer.value_id;
          question.Answers[i] = answer;
          question.AnswerID = answer.ms_id;
          question.selectAnsValue = answer.value_id;
          question.AnswerText = answer.ControlAns;
          question.pageto = answer.pageto;
          question.otherAnswer = null;

          if (question.isSoftRequired) {
            question.isSoftRequiredHandle = true;
          }

          if (answer.isOther) {
            question.isOtherAnswer = true;
          } else {
            question.isOtherAnswer = false;
          }
        } else {
          question.Answers[i].ControlAns = null;
          question.Answers[i].selectdId = 0;
        }
      }
      this.changeDetect.detectChanges();
      this.UpdateQuestionsData(question);
    }
  }

  ClickEventHandling(answer: Answers, question: Questions) {
    if (answer.selectdId == 0) {
      return;
    }

    if (question.Answers != null) {
      answer.selectdId = 0;
      answer.ControlAns = null;
      const updateItem = question.Answers.find((e) => e.ms_id == answer.ms_id);
      const index = question.Answers.indexOf(updateItem);
      question.Answers[index] = answer;
      question.AnswerID = 0;
      question.selectAnsValue = 0;
      question.pageto = 0;
      question.AnswerText = null;
      question.otherAnswer = null;
      question.isOtherAnswer = false;
      this.UpdateQuestionsData(question);

      if (question.isSoftRequired) {
        question.isSoftRequiredHandle = false;
      }
      this.changeDetect.detectChanges();
      this.UpdateQuestionsData(question);
    }
  }

  getPipingTitle(group_no: number): string {
    return this.service.getPiping(group_no);
  }

  getHiddenQuestions(questions: Questions, service: ParticipationDataService) {
    if (
      service.getGroupType()?.toLowerCase() == 'preview' &&
      service.getPreviewData().isShowHiddenQN
    ) {
      return true;
    } else {
      return (
        (
        questions.population_type != 2 &&
        questions.population_type != 5 &&
        questions.isCQHide == false) ||
        service.getisEditResponse() == true
      );
    }
  }

nextQuestion(event) {
    if (
      this.service.isNewParticipation &&
      (this.service.surveyFormat == 1 || this.service.surveyFormat == 2) &&
      this.questions.length == 1 &&
      this.service.isAutoScroll
    ) {
      this.service.gotoNextQuestion(this.questions[0], event);
    } else if (this.service.surveyFormat == 3 && this.questions.length == 1) {
      var currElem = $('.active-ques');
      var nextElem = currElem.nextAll('.inactive-ques').has('.question-data').eq(0);
      var afterNextElem = currElem.nextAll('.inactive-ques').has('.question-data').eq(1);
      if (nextElem.length > 0) {
        $('.back-arrow').removeClass('disabled');
        this.service.hideQuestion(currElem[0]);
        let isHidden = $(nextElem).find('.question-data').attr('hidden');

        if (isHidden) {
          this.service.showQuestion(afterNextElem[0]);
        } else {
          this.service.showQuestion(nextElem[0]);
        }

        if (afterNextElem.length == 0 && $('.next-button').length == 0) {
          $('.next-arrow').addClass('disabled');
        }
      } else {
        if ($('.next-button').length != 0) {
          $('.next-button').trigger('click');
        }
      }
    }
  }

  getAnsImageCSS() {
    if (this.questions.filter((e) => e.Answers[0].hasImage || e.Answers[0].hasMedia).length == 0) {
      return '';
    } else {
      return 'hasImage';
    }
  }

  trackByUniqueNumber(index: number, question: Questions): string {
    return question?.UniqueNumber?.toString();
  }

  trackByValueId(index: number, answers: Answers): string {
    return answers.value_id + answers.zarca_q_id?.toString();
  }

  gotoNextQuestion(question: Questions, event) {
    this.service.gotoNextQuestion(question, event);
  }

  setLabelWidth(elemid) {
    const element = this.elementRef.nativeElement.querySelector(elemid) as HTMLElement;
    if (!element) return;
    
    let srsQuesWidth = 0;
    let srsQuesMinWidth = 0;
    
    // Find all srs-question elements inside the provided element
    const srsQuestions = element.querySelectorAll('.srs-question') as NodeListOf<HTMLElement>;
    
    // Calculate the maximum width and set styling
    Array.from(srsQuestions).forEach(question => {
      const questionWidth = question.offsetWidth;
      if (questionWidth > srsQuesWidth) {
        srsQuesWidth = questionWidth;
        srsQuesMinWidth = questionWidth + 10;
      }
    });
    
    // Apply size limits
    if (srsQuesWidth > 220) {
      srsQuesWidth = 220;
    }
    
    if (srsQuesMinWidth > 220) {
      srsQuesMinWidth = 220;
    }
    
    // Apply styling to all srs-question elements
    Array.from(srsQuestions).forEach(question => {
      this.renderer.setStyle(question, 'min-width', srsQuesMinWidth + 'px');
      this.renderer.setStyle(question, 'white-space', 'normal');
    });
  }

  gotoNextQuestionKeyboard(question, event) {
    event.preventDefault();
    this.gotoNextQuestion(question, event.target);
  }
  
  getTrimString(strValue: number) {
    return strValue?.toString().trim();
  }
    isQuestionsPostPopulated(): boolean {
    let postpopQues =  this.questions.filter((e) => e.population_type == 4 || e.population_type == 5);
    if(postpopQues.length > 0 && this.service.getisEditPostPop() == true) {
      return true;
    }
    return false;
  }
    isPostEditDisable(question:Questions):boolean{
    if(this.service.getisEditPostPop() ==true
      && (question.population_type != 4 && question.population_type != 5)){
      return true;
    }
    return false;
  }
}
